import base64Conversion from './base64conversion';

export default function getTardiesDetentions(schoolCode, studentNo, studentId) {
  const header = base64Conversion();
  return fetch(`${process.env.REACT_APP_API_HEAD}/getStudentTotalTardiesDetentions`, {
    method: 'POST',
    body: JSON.stringify({
      school_code: schoolCode,
      student_no: studentNo,
      student_id: studentId,
    }),
    headers: {
      'content-type': 'application/json',
      Authorization: header,
    },
  });
}
